module.exports = __webpack_public_path__ + "static/media/Minnie.50734560.jpg";